import { render, staticRenderFns } from "./MineRouter.vue?vue&type=template&id=072274b9&scoped=true"
import script from "./MineRouter.vue?vue&type=script&lang=js"
export * from "./MineRouter.vue?vue&type=script&lang=js"
import style0 from "./MineRouter.vue?vue&type=style&index=0&id=072274b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072274b9",
  null
  
)

export default component.exports